<template>
  <div>
    <div v-if="listType == 'liste'">
      <el-col
        class="type-heading-main"
        v-for="(type, index) in types"
        :key="index"
      >
        <h1
          class="mt-10 mb-5 type-heading"
          v-if="getProducteurProduct(type).length > 0"
        >
          {{ type }}
        </h1>
        <el-col
          :xs="24"
          :sm="24"
          :md="24"
          v-for="(provider, index) in getProducteurProduct(type)"
          :key="index + 10000"
          :span="span"
          :class="isMobileLayout ? 'padListElement--mobile' : 'padListElement'"
        >
          <ProviderCardListView
            :provider="provider"
            :is-filter-visible="isFilterVisible"
          />
        </el-col>
      </el-col>
    </div>
    <div v-else>
      <el-col
        v-for="provider in dataProvider"
        :key="provider.id"
        :span="span"
        :class="isMobileLayout ? 'padListElement--mobile' : 'padListElement'"
      >
        <ProviderCard
          :provider="provider"
          :is-filter-visible="isFilterVisible"
        />
      </el-col>
    </div>
  </div>
</template>

<script>
import layoutUtils from "@/utils/layout-utils";

import ProviderCard from "./provider-card.vue";
import ProviderCardListView from "./provider-card-liste-view.vue";

export default {
  components: {
    ProviderCard,
    ProviderCardListView,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({
        countries: [],
      }),
    },
    providers: {
      type: Array,
      default: () => [],
    },
    span: {
      type: Number,
      default: 0,
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
    listType: {
      type: String,
      default: "tuiles",
    },
    isShorting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      types: [],
      dataProvider: Object.assign([], this.providers),
    };
  },
  computed: {
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
  created() {
    this.setProvidersType();
  },
  watch: {
    providers() {
      this.sortedArray();
    },
  },
  methods: {
    setProvidersType() {
      let type = [];
      this.filters.countries.forEach((value) => {
        type.push(value.name);
      });
      this.types = type;
      this.types.sort(function (a, b) {
        return a === b ? 0 : a < b ? -1 : 1;
      });
    },
    getProducteurProduct(type) {
      let tempProvider = Object.assign([], this.providers);
      return tempProvider.filter(
        (p) =>
          p.id != null && p.origins != "" && p.origins[0].country.name === type
      );
    },
    sortedArray: function () {
      let tempProvider = Object.assign([], this.providers);
      tempProvider.sort(function (a, b) {
        return a.name === b.name ? 0 : a.name < b.name ? -1 : 1;
      });
      if(this.isShorting){
        this.dataProvider = tempProvider;
      }else{
        this.dataProvider = this.providers;
      }
      
    },
  },
};
</script>

<style scoped lang="scss">
.padListElement--mobile {
  padding: 4px 4px 0 4px;
  margin-right: 0;
}
.padListElement {
  padding: 4px 4px 0 16px;
  margin-right: 0;
}
.type-heading {
  color: #65666b;
}
.type-heading-main {
  h1 {
    text-align: center;
    font-size: 20px;
  }
}
</style>
